// src/stores/counterStore.js
import { defineStore } from 'pinia';
import { useFirebaseStore } from '@/stores/firebase';
import store from '@/state/store'
import { dateInYyyyMmDdHhMmSs } from "@/utils"

export const useSenhaStore = defineStore('senha', {
  state: () => ({
    senha: {},
  }),

  getters: {
  },

  actions: {
    create(senha) {
      return new Promise(async (resolve, reject) => {
        const firebaseStore = useFirebaseStore()

        await firebaseStore.createSenha(senha).then(response => {
          this.realTime(senha.id)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    getAll() {
      return new Promise(async (resolve, reject) => {
        const firebaseStore = useFirebaseStore()

        await firebaseStore.getSenhas().then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    get(id) {
      return new Promise(async (resolve, reject) => {
        const firebaseStore = useFirebaseStore()

        await firebaseStore.getSenha(id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    realTime(id) {
      const firebaseStore = useFirebaseStore()
      firebaseStore.realTimeSenha(id);
    },

    closeRealTime(id) {
      const firebaseStore = useFirebaseStore()
      firebaseStore.closeRealTimeSenha(id);
    },

    update(senha) {
      return new Promise(async (resolve, reject) => {
        const firebaseStore = useFirebaseStore()

        await firebaseStore.updateSenha(senha).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    delete(id) {
      return new Promise(async (resolve, reject) => {
        const firebaseStore = useFirebaseStore()

        await firebaseStore.deleteSenha(id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    async startSenhaTotemRealTime() {      
      const idTotem = store.state.sessao.totem.idTotem
      if (!idTotem) return

      await this
        .get(idTotem)
        .then(async (response) => {
          if (response) {
            this.realTime(idTotem)
          } else {
            const senha = {
              id: idTotem,
              createdAt: dateInYyyyMmDdHhMmSs(new Date()),
              updatedAt: dateInYyyyMmDdHhMmSs(new Date()),
            };
            await this.create(senha);
          }
        });
    },

    async updateSenhaTotemCollection() {
      const idTotem = store.state.sessao.totem.idTotem
      
      if (!idTotem) return

      return await this
        .get(idTotem)
        .then(async (response) => {
          if (response) {
            const senha = {
              ...response,
              updatedAt: dateInYyyyMmDdHhMmSs(new Date()),
            };
            await this.update(senha);
          } else {
            const senha = {
              id: idTotem,
              createdAt: dateInYyyyMmDdHhMmSs(new Date()),
              updatedAt: dateInYyyyMmDdHhMmSs(new Date()),
            };
            await this.create(senha);
          }
        });
    },
  }
});
